// api/roleApi.js - Rol yönetimi API istekleri
import apiClient from './apiClient';

// Tüm rolleri getir
export const getAllRoles = async () => {
  return await apiClient.get('/roles');
};

// Temel rol bilgilerini getir (yetki gerektirmez)
export const getBasicRoleInfo = async () => {
  return await apiClient.get('/roles/basic');
};

// Temel rol izinlerini getir (yetki gerektirmez)
export const getBasicRolePermissions = async () => {
  return await apiClient.get('/roles/permissions/basic');
};

// Belirli bir rolü getir
export const getRole = async (id) => {
  return await apiClient.get(`/roles/${id}`);
};

// Kurulum için rolleri getir (auth gerektirmez)
export const getSetupRoles = async () => {
  return await apiClient.get('/roles/setup');
};

// Kurulum için izinleri getir (auth gerektirmez)
export const getSetupPermissions = async () => {
  return await apiClient.get('/roles/permissions/setup');
};

// Tüm izinleri getir
export const getAllPermissions = async () => {
  return await apiClient.get('/roles/permissions/all');
};

// Yeni rol oluştur
export const createRole = async (roleData) => {
  return await apiClient.post('/roles', roleData);
};

// Rol güncelle
export const updateRole = async (id, roleData) => {
  return await apiClient.put(`/roles/${id}`, roleData);
};

// Rol sil
export const deleteRole = async (id) => {
  return await apiClient.delete(`/roles/${id}`);
};

// Bir rolün izinlerini getir
export const getRolePermissions = async (id) => {
  return await apiClient.get(`/roles/${id}/permissions`);
};

// Bir rolün izinlerini güncelle
export const updateRolePermissions = async (id, permissions) => {
  console.log(`Rol ID ${id} için izinler gönderiliyor:`, permissions);
  
  // permissions parametresinin dizi olduğundan emin ol
  const permissionsArray = Array.isArray(permissions) ? permissions : [];
  
  // İzin ID'lerini doğrudan dizi olarak gönder, obje içinde göndermiyoruz
  return await apiClient.put(`/roles/${id}/permissions`, permissionsArray);
};

// Bir rolün ödeme yöntemlerini getir
export const getRolePaymentMethods = async (id) => {
  try {
    const response = await apiClient.get(`/roles/${id}/payment-methods`);
    console.log(`Rol ID ${id} için alınan ödeme yöntemleri:`, response);
    return response;
  } catch (error) {
    console.error(`Rol ID ${id} için ödeme yöntemleri alınırken hata:`, error);
    return []; // Hata durumunda boş dizi döndür
  }
};

// Bir rolün ödeme yöntemlerini güncelle
export const updateRolePaymentMethods = async (id, paymentMethodIds) => {
  console.log(`Rol ID ${id} için ödeme yöntemleri gönderiliyor:`, paymentMethodIds);
  
  // paymentMethodIds parametresinin dizi olduğundan emin ol
  const methodIdsArray = Array.isArray(paymentMethodIds) ? paymentMethodIds : [];
  
  try {
    const response = await apiClient.put(`/roles/${id}/payment-methods`, { paymentMethodIds: methodIdsArray });
    console.log(`Rol ID ${id} için ödeme yöntemleri güncelleme yanıtı:`, response);
    return response;
  } catch (error) {
    console.error(`Rol ID ${id} için ödeme yöntemleri güncellenirken hata:`, error);
    throw error; // Hatayı yeniden fırlat
  }
};

// Kullanıcının erişebildiği ödeme yöntemlerini getir
export const getUserAccessiblePaymentMethods = async () => {
  try {
    console.log('getUserAccessiblePaymentMethods - API isteği gönderiliyor');
    const response = await apiClient.get('/roles/user/payment-methods');
    console.log('Kullanıcının erişebildiği ödeme yöntemleri ham yanıt:', response);
    
    // API yanıt formatını kontrol et ve düzgün veriyi döndür
    if (!response) {
      console.warn('Boş yanıt alındı');
      return [];
    }
    
    // Yanıt bir dizi mi?
    if (Array.isArray(response)) {
      console.log('Yanıt doğrudan bir dizi:', response.length);
      return response;
    }
    
    // Yanıt bir nesne ve içinde data alanı varsa
    if (response && typeof response === 'object') {
      // Tipik başarılı yanıt formatı: { status: 'success', data: [...] }
      if (response.status === 'success' && Array.isArray(response.data)) {
        console.log('Başarılı yanıt içinde data dizisi:', response.data.length);
        return response.data;
      }
      
      // Alternatif format: { data: [...] }
      if (response.data && Array.isArray(response.data)) {
        console.log('Yanıt içinde data dizisi:', response.data.length);
        return response.data;
      }
      
      // İç içe format: { data: { data: [...] } }
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        console.log('İç içe data dizisi:', response.data.data.length);
        return response.data.data;
      }
      
      // Diğer olası alanları kontrol et
      const possibleKeys = ['methods', 'paymentMethods', 'items', 'results', 'list'];
      for (const key of possibleKeys) {
        if (response[key] && Array.isArray(response[key])) {
          console.log(`${key} alanında dizi bulundu:`, response[key].length);
          return response[key];
        }
      }
      
      // response.data içindeki olası alanları kontrol et
      if (response.data && typeof response.data === 'object') {
        for (const key of possibleKeys) {
          if (response.data[key] && Array.isArray(response.data[key])) {
            console.log(`data.${key} alanında dizi bulundu:`, response.data[key].length);
            return response.data[key];
          }
        }
      }
      
      // Hiçbir format tanınmadıysa, tüm alanları kontrol et
      console.log('Standart yanıt formatı bulunamadı, tüm alanlar:', Object.keys(response));
      
      // Yanıtta dizi içeren herhangi bir alan var mı?
      for (const key in response) {
        if (Array.isArray(response[key])) {
          console.log(`${key} alanında dizi bulundu, kullanılıyor:`, response[key].length);
          return response[key];
        }
      }
    }
    
    // Hiçbir dizi bulunamadı, boş dizi döndür
    console.warn('Yanıtta ödeme yöntemi dizisi bulunamadı');
    return [];
  } catch (error) {
    console.error('Kullanıcının erişebildiği ödeme yöntemleri alınırken hata:', error);
    return []; // Hata durumunda boş dizi döndür, böylece UI hata vermez
  }
};

// Kullanıcının erişebildiği ödeme yöntemlerini getir - Temel erişim yöntemi
// Bu fonksiyon, kullanıcı manage_roles izni olmadığında alternatif olarak kullanılabilir
export const getUserAccessiblePaymentMethodsBasic = async () => {
  try {
    console.log('getUserAccessiblePaymentMethodsBasic - API isteği gönderiliyor');
    
    // Temel izinleri getiren API'yi kullan - Bu API tüm kullanıcılara açıktır
    const response = await apiClient.get('/roles/permissions/basic');
    console.log('Temel erişim verileri alındı');
    
    if (!response || !response.data || !Array.isArray(response.data)) {
      console.warn('Temel API yanıtı boş veya geçersiz format');
      return [];
    }
    
    // Mevcut tüm ödeme yöntemleri - sabit liste
    // NOT: Gerçek senaryoda bu liste API'den gelmeli, ancak şu an örnek olarak kullanıyoruz
    const allPaymentMethods = [
      { id: 4, name: 'MovenBank', code: 'moven_b', display_order: 1 },
      { id: 5, name: 'London', code: 'london_b', display_order: 2 },
      { id: 6, name: 'Safepays', code: 'safepays_b', display_order: 3 },
      { id: 13, name: 'PHPay', code: 'ph_b', display_order: 2 },
      { id: 14, name: 'MovenPapara', code: 'moven_p', display_order: 0 },
      { id: 15, name: 'MultiPayBankin', code: 'multipay_b', display_order: 0 },
      { id: 16, name: 'JetHavale', code: 'jet_h', display_order: 0 },
      { id: 17, name: 'YeniHavale', code: 'yeni_h', display_order: 0 },
      { id: 18, name: 'FPapara', code: 'f_p', display_order: 0 },
      { id: 19, name: 'HızlıPapara', code: 'hizli_p', display_order: 0 }
    ];
    
    // Backend artık sadece kullanıcının kendi rolünü gönderiyor - array içinde tek eleman
    if (response.data.length === 0) {
      console.warn('API yanıtında rol bulunamadı');
      return [];
    }
    
    // İlk (ve muhtemelen tek) rol bilgisini al - yeni API formatına uygun olarak
    const userRole = response.data[0];
    console.log(`Kullanıcı rolü: ${userRole.name} (ID: ${userRole.id})`);
    
    // Rol işlemlerini yap
    return processRoleForPaymentMethods(userRole, allPaymentMethods);
  } catch (error) {
    console.error('Temel erişim yöntemiyle ödeme yöntemleri alınırken hata:', error);
    
    // Hata durumunda varsayılan ödeme yöntemlerini döndür
    const defaultPaymentMethods = [
      { id: 4, name: 'MovenBank', code: 'moven_b' },
      { id: 5, name: 'London', code: 'london_b' },
      { id: 14, name: 'MovenPapara', code: 'moven_p' }
    ];
    
    console.warn('Hata nedeniyle sınırlı varsayılan ödeme yöntemleri kullanılıyor');
    return defaultPaymentMethods;
  }
};

// Yardımcı fonksiyon - belirli bir rol için ödeme yöntemlerini işle
const processRoleForPaymentMethods = (role, allPaymentMethods) => {
  // Admin ve casi rollerinde tüm ödeme yöntemlerine erişim var
  if (role.name === 'admin' || role.name === 'casi') {
    console.log(`${role.name} rolü için tüm ödeme yöntemleri döndürülüyor`);
    return allPaymentMethods;
  }
  
  // Rolün manage_payment_methods izni varsa tüm yöntemlere erişimi var
  if (role.permissions && role.permissions.includes('manage_payment_methods')) {
    console.log('Role manage_payment_methods izni var, tüm ödeme yöntemleri döndürülüyor');
    return allPaymentMethods;
  }
  
  // Rol-ödeme yöntemi ilişkilerini kontrol et
  if (role.payment_methods && Array.isArray(role.payment_methods) && role.payment_methods.length > 0) {
    console.log(`Rol için ${role.payment_methods.length} ödeme yöntemi ilişkisi bulundu`);
    
    // Rolün erişebildiği ödeme yöntemlerini filtrele
    const accessibleMethods = allPaymentMethods.filter(method => 
      role.payment_methods.includes(method.id) || 
      role.payment_methods.includes(method.id.toString())
    );
    
    console.log(`Filtreden sonra ${accessibleMethods.length} ödeme yöntemi kaldı`);
    
    if (accessibleMethods.length > 0) {
      return accessibleMethods;
    }
    
    console.warn('Rol-ödeme yöntemi ilişkileri var ama eşleşen yöntem bulunamadı');
  } else {
    console.warn('Role ait ödeme yöntemi ilişkisi bulunamadı');
  }
  
  // Varsayılan olarak boş dizi döndür - izin yok
  return [];
};

export default {
  getAllRoles,
  getRole,
  getSetupRoles,
  getSetupPermissions,
  getAllPermissions,
  createRole,
  updateRole,
  deleteRole,
  getRolePermissions,
  updateRolePermissions,
  getRolePaymentMethods,
  updateRolePaymentMethods,
  getUserAccessiblePaymentMethods,
  getUserAccessiblePaymentMethodsBasic,
  getBasicRoleInfo,
  getBasicRolePermissions
}; 